import { render } from "./view-header.vue?vue&type=template&id=1c5435c5&scoped=true"
import script from "./view-header.js?vue&type=script&lang=js&external"
export * from "./view-header.js?vue&type=script&lang=js&external"

import "./view-header.scss?vue&type=style&index=0&id=1c5435c5&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5435c5"]])

export default __exports__